import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { ModalController, Platform, ToastController } from '@ionic/angular';

import { Sale } from '../../../../models/sale/sale.model';
import { Stylist } from '../../../../models/stylist/stylist.model';
import { Payment } from '../../../../models/payment/payment.model';
import { Tip } from '../../../../models/tip/tip.model';
import {
  StylistSquareCredentials,
  SquarePOSService,
} from '../../../../services/square-pos.service';
import { UserService } from '../../../../services/user.service';
import { StylistService } from '../../../../services/stylist.service';
import {
  SaleService,
  SALE_CHECKOUT_TYPE,
} from '../../../../services/sale.service';

import { Router } from '@angular/router';

import { SaleTipFormPage } from '../../../sale-checkout/sale-tip-form/sale-tip-form.page';
import { SalePaymentPickerPage } from '../../../sale-checkout/sale-payment-picker/sale-payment-picker.page';
import { SquareLocationPickerComponent } from '../../../../components/square-location-picker/square-location-picker.component';
import { SalePaymentFormPage } from '../../../sale-checkout/sale-payment-form/sale-payment-form.page';
import {
  StripePayment,
  StripeService,
} from '../../../../services/stripe.service';
import { SalePaymentStripeComponent } from 'src/app/sales/sale-checkout/sale-payment-stripe/sale-payment-stripe.component';
import { SplitTipComponent } from 'src/app/sales/sale-checkout/sale-payment-stripe/split-tip/split-tip.component';
import { SaleRefundPickerComponent } from '../sale-refund-picker/sale-refund-picker.component';
import { SaleRefundCardConfirmationComponent } from '../sale-refund-card-confirmation/sale-refund-card-confirmation.component';
import { SaleRefundInteracComponent } from '../sale-refund-interac/sale-refund-interac.component';
import { NavigationStateService } from '../../../../services/navigation-state.service';
@Component({
  selector: 'smr-sale-checkout-buttons',
  templateUrl: './sale-checkout-buttons.component.html',
  styleUrls: ['./sale-checkout-buttons.component.scss'],
})
export class SaleCheckoutButtonsComponent implements OnInit, OnChanges {
  @Input() sale: Sale;

  @Input() cashTip: boolean = false;

  public saleRefundParent: Sale;
  public isLoading: boolean;

  public errorOccured: boolean;

  public credentials: StylistSquareCredentials;

  @Output() saleUpdated = new EventEmitter<Sale>();

  @Input() isFromBookings: boolean = false;
  @Input() isFromRegisterClosure;

  public hasStripeAccount: boolean = false;

  public hardwareIsConnected: boolean = false;

  public stripeAccountInfo: Array<StripePayment>;

  public stylistNum: number;

  constructor(
    private squarePOSService: SquarePOSService,
    private userService: UserService,
    private saleService: SaleService,
    private modalCtrl: ModalController,
    //private navCtrl: NavController,
    private platform: Platform,
    private changeDetectorRef: ChangeDetectorRef,
    private router: Router,
    private stripeService: StripeService,
    private stylistService: StylistService,
    private toastCtrl: ToastController,
    private navigationStateService: NavigationStateService
  ) {
  }

  public ngOnInit() {
    if (this.sale.isRefundSale()) {
      this.saleService
        .loadSaleByID(this.sale.saleRefundParent)
        .subscribe((sale) => {
          this.saleRefundParent = sale;
        });
    }
    // this.loadCredentials();
    this.stylistService.getStylists().subscribe((stylists) => {
      this.stylistNum = stylists.count();
    });
    this.loadStripeData();
  }

  public ngOnChanges(changes) {
    if (changes.sale) {
      const amount = () => this.sale.balance;
    }
  }

  public async loadStripeData() {
    try {
      const { stripeAccountInfo } = await this.stripeService.loadStripeAccountInfo().toPromise();
      this.stripeAccountInfo = stripeAccountInfo.toArray();
      this.hasStripeAccount = this.stripeAccountInfo.length !== 0;

      if (!this.hasStripeAccount) return;

      await this.manageCardReaders();
      this.changeDetectorRef.detectChanges();
    } catch (err) {
      console.error(err);
    }
  }


  private async manageCardReaders() {
    const res = await this.stripeService.discoverReaders();

    if (res.code === 'reader_not_found' || res.code === 'reader_error') return;

    try {
      const reader = res[0];
      this.hardwareIsConnected = (await this.stripeService.getStatus(reader)) === 'connected';
    } catch {
    }

    if (this.hardwareIsConnected) return;

    await this.tryConnectReader();
  }

  private async tryConnectReader() {
    try {
      const connectResponse = await this.connectReaderFromLocalStorage();
      this.hardwareIsConnected = !connectResponse['error'];
    } catch (error) {
      await this.connectFirstAvailableReader();
    }
  }

  private async connectReaderFromLocalStorage() {
    const storedReader = localStorage.getItem('cardReader');
    if (!storedReader) throw new Error("No card reader stored");

    return this.stripeService.connectReader(JSON.parse(storedReader));
  }

  private async connectFirstAvailableReader() {
    const stripeReaders = await this.stripeService.discoverReaders();
    if (!stripeReaders.discoveredReaders.length) throw new Error("No readers discovered");

    const connectResponse = await this.stripeService.connectReader(stripeReaders.discoveredReaders[0]);
    if (!connectResponse['error']) {
      this.hardwareIsConnected = true;
    } else {
    }
  }

  public releaseSquareFeature(): boolean {
    return true;
  }

  public async loadCredentials() {
    if (!this.releaseSquareFeature()) {
      return;
    }

    if (!this.platform.is('capacitor')) {
      return;
    }

    this.isLoading = true;
    this.errorOccured = false;
    this.changeDetectorRef.markForCheck();
    this.squarePOSService.getStylistOAuthCredentials().subscribe({
      next: async (credentials) => {
        this.credentials = credentials;

        if (this.isSquarePOSEnabled()) {
          if (!this.squarePOSService.getSquareBusinessLocation()) {
            // show location picker
            const modal = await this.modalCtrl.create({
              //component: SquareLocationPickerPage,
              component: SquareLocationPickerComponent,
              componentProps: { hideCloseButton: true },
              backdropDismiss: false,
              cssClass: 'modal-bg',
            });
            modal.onWillDismiss().then((data) => {
              if (data) {
                // this.selectedSquareLocation = data;
                this.changeDetectorRef.markForCheck();
              }
            });
            await modal.present();
          }
        }

        this.isLoading = false;
        this.changeDetectorRef.markForCheck();
      },
      error: (err) => {
        this.isLoading = false;
        if (err.err_msg === 'Credentials not found') {
          this.errorOccured = false;
        } else {
          this.errorOccured = true;
        }
        this.changeDetectorRef.markForCheck();
      },
    });
  }

  public isSquarePOSEnabled(): boolean {
    if (!this.releaseSquareFeature()) {
      return;
    }

    if (!this.platform.is('capacitor')) {
      return false;
    }

    return this.credentials !== undefined && this.credentials !== null;
  }

  public onSquareCheckOut() {
    // TODO: check if this new Payment is right after Square Check Out
    const payment: Payment = new Payment({
      id: undefined,
      name: '',
      type: 11, // Temporariliy set it to Square as payment type
      amount: this.sale.total, // Important: We charge the WHOLE amount to Square and retrieve the Transaction details in SaleConfirmationPage
    });

    // this.saleService.setSaleToBeCheckedOut(this.sale, SALE_CHECKOUT_TYPE.SquarePOS, this.checkOutPromise);
    this.squarePOSService.setSquarePayment(payment);
    this.squarePOSService.launchPOS(this.sale);
  }

  public async addTip(tip: number) {
    let firstStylistFromThisSale: Stylist = this.userService.getUser();

    this.sale.getLineItems().some((lineitem) => {
      if (lineitem.getType() === 'service') {
        if (lineitem.getStylist()) {
          firstStylistFromThisSale = lineitem.getStylist();
        }
        return true;
      }

      return false;
    });

    const modal = await this.modalCtrl.create({
      component: SaleTipFormPage,
      componentProps: {
        sale: this.sale,
        tip: new Tip({
          id: undefined,
          stylistID: firstStylistFromThisSale.id,
          stylist: firstStylistFromThisSale,
          value: tip > 0 ? tip : undefined,
          isRefunded: 0,
        }),
        showRemoveButton: false,
      },
      cssClass: 'modal-bg',
    });
    modal.onWillDismiss().then(({data}) => {
      if (data && data.tip.value != 0) {
        this.sale = this.sale.addTip(data.tip);
        this.saleUpdated.emit(this.sale);
        this.changeDetectorRef.markForCheck();

        if (tip > 0 && this.sale.isSaleReadyForCheckOut()) {
          this.completeSale();
        }
      }
    });
    await modal.present();
  }

  public async addPayment(dropDownPushed) {
    if (this.sale.isSaleReadyForCheckOut()) {
      this.completeSale();
      return;
    }

    let disableCashButton: boolean = false;

    // disable cash button if there's already a cash in the sale
    this.sale.payments.forEach((payment) => {
      if (payment.type === 1) {
        disableCashButton = true;
      }
    });

    if (this.hasStripeAccount) {
      const stripeModal = await this.modalCtrl.create({
        component: SalePaymentStripeComponent,
        componentProps: {
          dropDownPushed: dropDownPushed,
          sale: this.sale,
          disableCashButton: disableCashButton,
          stripePaymentType: this.hasStripeAccount,
        },
        backdropDismiss: false
      });
      stripeModal.onWillDismiss().then(({data}) => {
        if (data) {
          if (data.cardPayment) {
            this.sale = this.sale.addPayment(data.payment);
            if (data.amountDetails.tip.amount == 0) {
              this.completeSale();
            } else {
              if (this.stylistNum == 1) {
                if (data.amountDetails.tip?.amount && data.amountDetails.tip.amount != 0) {
                  const tip: Tip = new Tip({
                    id: undefined,
                    stylistID: this.userService.getUser().getID(),
                    stylist: this.userService.getUser(),
                    value: data.amountDetails.tip.amount / 100,
                    isRefunded: 0,
                  });
                  this.sale = this.sale.addTip(tip);
                }
                this.saleUpdated.emit(this.sale);
                this.changeDetectorRef.markForCheck();
                this.completeSale();
              } else {
                this.splitTip(data.amountDetails);
              }
            }
          } else {
            this.completeSaleAfterModalClose(data);
          }
        }
      });
      stripeModal.present();
    } else {
      const modal = await this.modalCtrl.create({
        component: SalePaymentPickerPage,
        componentProps: { disableCashButton: disableCashButton },
        cssClass: 'modal-bg',
      });
      modal.onWillDismiss().then(async ({data}) => {
        if (data) {
          this.completeSaleAfterModalClose(data);
        }
      });

      modal.present();
    }
  }

  async splitTip(amountDetails) {
    const modal = await this.modalCtrl.create({
      component: SplitTipComponent,
      backdropDismiss: false,
      componentProps: {
        sale: this.sale,
        amountDetails: amountDetails,
      },
    });

    modal.onWillDismiss().then(({data}) => {
      if (data) {
        this.sale = data;
        this.saleUpdated.emit(this.sale);
        this.changeDetectorRef.markForCheck();
        this.completeSale();
      }
    });

    modal.present();
  }

  public payCashWithouTip() {
    this.sale = this.sale.editPaymentAmount(0, this.sale.total);
    this.saleUpdated.emit(this.sale);
    this.changeDetectorRef.markForCheck();
    this.completeSale();
  }

  public async completeSaleAfterModalClose(data) {
    let payment = data.payment;
    if (data.otherPayment) {
      const paymentFormModal = await this.modalCtrl.create({
        component: SalePaymentFormPage,
        componentProps: {
          sale: this.sale,
          payment: payment,
          paymentIndex: -1,
          showRemoveButton: false,
        },
        cssClass: 'modal-bg',
      });
      paymentFormModal.onWillDismiss().then(({data}) => {
        if (data) {
          this.sale = this.sale.addPayment(data.payment);
          if (data.tips) {
            this.sale = this.sale.addTip(
              new Tip({
                id: undefined,
                stylistID: data.tipsForStylist.id,
                stylist: data.tipsForStylist,
                value: data.tips,
                isRefunded: 0,
              })
            );
          }
          this.saleUpdated.emit(this.sale);
          this.changeDetectorRef.markForCheck();
          this.completeSale();
        }
      });
      paymentFormModal.present();
    } else {
      this.sale = this.sale.addPayment(payment);
      this.saleUpdated.emit(this.sale);
      this.changeDetectorRef.markForCheck();
      this.completeSale();
    }

    // }
  }

  public completeSale() {
    this.saleService.setSaleToBeCheckedOut(
      this.sale,
      SALE_CHECKOUT_TYPE.salonMonsterPay
    );

    this.navigationStateService.setState({
      sale: this.sale,
      isFromBookings: this.isFromBookings,
      isFromRegisterClosure: this.isFromRegisterClosure,
    });

    if (this.sale.isSaleReadyForCheckOut()) {
      this.router.navigate(
        ['./sales/sale-checkout/sale-confirmation']
      );
    }
  }

  public async selectRefundMethod() {
    const modal = await this.modalCtrl.create({
      component: SaleRefundPickerComponent,
      componentProps: {
        saleRefundParent: this.saleRefundParent,
      },
    });

    modal.onWillDismiss().then(async ({data}) => {
      if (data) {
        if (data.refundType == 'card') {
          const cardInfo = data.cardInfo;
          const cardRefundModal = await this.modalCtrl.create({
            component: SaleRefundCardConfirmationComponent,
            componentProps: {
              amount: 0 - this.sale.total,
              cardInfo: cardInfo,
            },
          });

          cardRefundModal.onWillDismiss().then(async ({data}) => {
            if (data) {
              if (cardInfo.isInterac) {

                const refundInteracModal = await this.modalCtrl.create({
                  component: SaleRefundInteracComponent,
                  componentProps: {
                    cardInfo: cardInfo,
                    sale: this.sale
                  }
                })

                refundInteracModal.onWillDismiss().then(({data}) => {
                  if (data) {
                    const payment: Payment = new Payment({
                      id: undefined,
                      name: '',
                      type: cardInfo.type,
                      amount: this.sale.total,
                    });

                    this.sale = this.sale.addPayment(payment);

                    this.completeSale();
                  }
                })
                refundInteracModal.present();

              } else {
                this.stripeService
                  .refund({
                    paymentIntentID: cardInfo.intentID,
                    amount: Math.round((0 - this.sale.total) * 100),
                  })
                  .subscribe((res) => {
                    const payment: Payment = new Payment({
                      id: undefined,
                      name: '',
                      type: cardInfo.type,
                      amount: this.sale.total,
                    });

                    this.sale = this.sale.addPayment(payment);

                    this.completeSale();
                  });
              }
            }
          });
          cardRefundModal.present();
        }
        if (data.refundType == 'cash') {
          const payment: Payment = new Payment({
            id: undefined,
            name: '',
            type: 1,
            amount: this.sale.total,
          });

          this.sale = this.sale.addPayment(payment);

          this.completeSale();
        }
        if (data.refundType == 'external') {
          const payment: Payment = new Payment({
            id: undefined,
            name: '',
            type: 25,
            amount: this.sale.total,
          });

          this.sale = this.sale.addPayment(payment);

          this.completeSale();
        }
      }
    });

    modal.present();
  }
}
